import axios from 'axios'
import qs from 'qs'
import ElementUI from 'element-ui';

function isShareContext() {
  if (typeof window === 'undefined') return false
  const pathname = String(window.location.pathname || '').toLowerCase()
  const search = String(window.location.search || '').toLowerCase()
  const hash = String(window.location.hash || '').toLowerCase()
  const inSharePath = pathname.includes('/share') || hash.includes('/share')
  const byQuery = search.includes('from=share') || search.includes('share=1') || search.includes('isshare=1') || search.includes('share=true') || search.includes('isshare=true')
  return inSharePath || byQuery
}

function goLoginIfNeeded() {
  if (isShareContext()) return
  if (typeof window === 'undefined') return
  if (window.__LOGIN_REDIRECTING__) return
  window.__LOGIN_REDIRECTING__ = true
  setTimeout(() => {
    window.location.href = '/login'
    window.__LOGIN_REDIRECTING__ = false
  }, 200)
}

export function request(config) {
  return new Promise((resolve, reject) => {

    // 1.创建axios的实例
    const instance = axios.create({
      baseURL: (config.baseUrl ? config.baseUrl : process.env.VUE_APP_URE),
      method: config.method || 'POST',
      params: config.params || {},
      // method: config.method == 1 ? 'POST' : 'GET',
      data: config.data || {},
      headers: {
        'Content-Type': (config.isHeader == 1 ? 'application/json' : 'application/x-www-form-urlencoded; charset=utf-8;'),
        'token': localStorage.getItem('USER_TOKEN') || ''
      },
      timeout: 30000
    })

    // 请求拦截
    instance.interceptors.request.use(config => {
      config.data = config.isHeader ? config.data : qs.stringify(config.data)
      const token = localStorage.getItem('USER_TOKEN') || ''
      if (!token.length && !isShareContext()) {
        ElementUI.Message({
          message: '登录失效，请重新登录',
          type: 'error'
        });
        goLoginIfNeeded()
      }
      return config
    })
    // 2.2.响应拦截
    instance.interceptors.response.use(res => {
      // console.log(res)
      if (res.data.code == 401) {
        if (isShareContext()) {
          reject(res)
          return
        }
        ElementUI.Message({
          message: '登录失效，请重新登录',
          type: 'error'
        });
        goLoginIfNeeded()
        reject(res)
      } else if (res.data.code == 200) {
        // 如果配置了 returnFullRes，就返回完整的 res.data，方便获取外层的 count、msg 等
        if (config.returnFullRes) {
          resolve(res.data)
        } else {
          resolve(res.data.data)
        }
      } else {
        ElementUI.Message({
          message: res.data.msg,
          type: 'error'
        });
        reject(res)
      }
    }, error => {
      if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
        ElementUI.Message({
          message: '请求超时',
          type: 'error'
        });
      }
      if (error && error.response && error.response.status == 401 && !isShareContext()) {
        goLoginIfNeeded()
      }
      reject(error)
    })

    // 3.发送真正的网络请求
    return instance(config)
  })
}
